export interface NewSkillReq {
  name: string;
  type: number;
  profession_id: string;
  education_id: string;
}

export enum SkillType {
  Unknown = 0,
  Skills = 1,
  Knowledge = 2,
  Softskill = 3,
  Language = 4,
}
